var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductCircleFlagUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_1828)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 24.479,
    width: 68.701,
    height: 21.76,
    fill: "#2E62D9"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 46.2409,
    width: 68.701,
    height: 21.76,
    fill: "#FC5454"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_186_1828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 0H0V68H68V0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 8.5H0V17H68V8.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 25.5H0V34H68V25.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 42.5H0V51H68V42.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 59.5H0V68H68V59.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1667 0H0V34H48.1667V0Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4658 13.9282L17.7031 16.2746H15.2361L17.2323 17.724L16.4696 20.0702L18.4658 18.6208L20.4607 20.0702L19.6982 17.724L21.6943 16.2746H19.2272L18.4658 13.9282Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2272 24.7419L18.4658 22.3958L17.7031 24.7419H15.2361L17.2323 26.1915L16.4696 28.5377L18.4658 27.0881L20.4607 28.5377L19.6982 26.1915L21.6943 24.7419H19.2272Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80085 24.7419L8.03926 22.3958L7.27656 24.7419H4.80957L6.80576 26.1915L6.04306 28.5377L8.03926 27.0881L10.0343 28.5377L9.27182 26.1915L11.2676 24.7419H8.80085Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03926 13.9282L7.27656 16.2746H4.80957L6.80576 17.724L6.04306 20.0702L8.03926 18.6208L10.0343 20.0702L9.27182 17.724L11.2676 16.2746H8.80085L8.03926 13.9282Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4658 5.46069L17.7031 7.80725H15.2361L17.2323 9.25681L16.4696 11.603L18.4658 10.1534L20.4607 11.603L19.6982 9.25681L21.6943 7.80725H19.2272L18.4658 5.46069Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03926 5.46069L7.27656 7.80725H4.80957L6.80576 9.25681L6.04306 11.603L8.03926 10.1534L10.0343 11.603L9.27182 9.25681L11.2676 7.80725H8.80085L8.03926 5.46069Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8914 13.9282L28.1288 16.2746H25.6619L27.6579 17.724L26.8955 20.0702L28.8914 18.6208L30.8866 20.0702L30.1239 17.724L32.1201 16.2746H29.6531L28.8914 13.9282Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6531 24.7419L28.8914 22.3958L28.1288 24.7419H25.6619L27.6579 26.1915L26.8955 28.5377L28.8914 27.0881L30.8866 28.5377L30.1239 26.1915L32.1201 24.7419H29.6531Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0795 24.7419L39.3179 22.3958L38.5552 24.7419H36.0884L38.0842 26.1915L37.3217 28.5377L39.3179 27.0881L41.313 28.5377L40.5503 26.1915L42.5465 24.7419H40.0795Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3179 13.9282L38.5552 16.2746H36.0884L38.0842 17.724L37.3217 20.0702L39.3179 18.6208L41.313 20.0702L40.5503 17.724L42.5465 16.2746H40.0795L39.3179 13.9282Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8914 5.46069L28.1288 7.80725H25.6619L27.6579 9.25681L26.8955 11.603L28.8914 10.1534L30.8866 11.603L30.1239 9.25681L32.1201 7.80725H29.6531L28.8914 5.46069Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3179 5.46069L38.5552 7.80725H36.0884L38.0842 9.25681L37.3217 11.603L39.3179 10.1534L41.313 11.603L40.5503 9.25681L42.5465 7.80725H40.0795L39.3179 5.46069Z",
    fill: "#F0F0F0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 33.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_1828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_186_1828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCircleFlagUsa);
export default __webpack_public_path__ + "static/media/product-circle-flag-usa.8645395a1334025353d5a15ec5f5fe5d.svg";
export { ForwardRef as ReactComponent };